export { default } from './ProductDetail';
